import { Typography, MenuItem, TextField, CircularProgress, Stack, Button, Box,  Dialog, DialogContent, DialogTitle, DialogActions, Backdrop, IconButton } from "@mui/material";
import React, {useEffect, useState, useContext, useMemo} from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../App";
import { API } from "../conf";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from "date-fns/locale/fr";
import '../asset/styles/Datepicker.css';
import moment from 'moment';
import DonateurForm from "./donateur-form";
import Header from "./Header";
import DonForm from "./don-form";
import PaymodeForm from "./pay-mode-form";
import { Add, Clear } from "@mui/icons-material";
registerLocale('fr', fr)

export default function RegistFond(props) {
    const navigate = useNavigate()
    const organisation = JSON.parse(sessionStorage.getItem('eglise'))
    const agent = JSON.parse(sessionStorage.getItem('user'))
    const { updateConnect } = useContext(Context)
    const [loading, setLoad] = useState(true)
    const [sending, setSend] = useState(false)
    const [open, SetOpen] = useState(false)
    const [open_choice, SetOpenChoice] = useState(false)
    const [donateurs, setDonateurs] = useState([])
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState(props.don?.eglise??'')
    const [anonyme, setAnonyme] = useState({})
    const [total, setTotal] = useState(props.total?? 0)
    const [reptotal, setReptotal] = useState(props.total?? 0)
    
    const [date, setDate] = useState(props.don?.date ? new Date(props.don.date) : '')
    const [donateur, setDonateur] = useState('')
    const [dime, setDime] = useState(props.don?.dime?? 0)
    const [offrande_globale, setOffrande_globale] = useState(props.don?.offrande_globale?? 0)
    const [offrande_spe_feam, setOffrande_spe_feam] = useState(props.don?.offrande_spe_feam?? [{libelle: '', montant:0, compte:''}])
    const [offrande_spe_eglise, setOffrande_spe_eglise] = useState(props.don?.offrande_spe_eglise?? [{libelle: '', montant:0, compte:''}])
    const [offrande_label_feam, setOffrande_label_feam] = useState([])
    const [offrande_label_eglise, setOffrande_label_eglise] = useState([])
    const [com, setCom] = useState('')
    
    const [pay_mode, setMode] = useState(props.don?.repartition ? Object.keys(props.don.repartition).filter(key => !['especes', 'cheques'].includes(key) || props.don.repartition[key].length>0) :[''])
    const [repEspeces, setRepEspeces] = useState(props.don?.repartition?.especes?.length>0 ? props.don?.repartition?.especes : [{montant:"", count: 0}])
    const [repCheques, setRepCheques] = useState(props.don?.repartition?.cheques?.length>0 ? props.don?.repartition?.cheques : [{banque:'', montant:0, num_cheque:''}])
    const [repVir, setRepVir] = useState(props.don?.repartition?.virement? {date:moment.utc(props.don.repartition.virement.date).format("yyyy-MM-DD"), montant:props.don.repartition.virement.montant, ref: props.don.repartition.virement.ref} : {date:"", montant:0, ref: ''})
    const [repCB, setRepCB] = useState(props.don?.repartition?.cb? {date:moment.utc(props.don.repartition.cb.date).format("yyyy-MM-DD"), montant:props.don.repartition.cb.montant, ref: props.don.repartition.cb.ref} : {date:"", montant:0, ref: ''})
    const [cheque_files, setFiles] = useState([''])

    const eglise = useMemo(()=>{
        if (organisation && !organisation.isFederation && !organisation.isUnion) {
            return organisation
        } else if (egliseId!=='') {
            return eglises.find(el=> el._id === egliseId)
        } else return
    }, [eglises, egliseId, organisation])

    function updateDonateurs(donator) {
        setDonateurs(old=>[donator,...old])
    }

    function handleSubmit() {
        setSend(true)
        SetOpen(false)
        const don = {
            date: date,
            donateur: donateur,
            dime: dime,
            offrande_globale: offrande_globale,
            offrande_spe_feam: offrande_spe_feam.filter(off => off.montant>0),
            offrande_spe_eglise: offrande_spe_eglise.filter(off => off.montant>0),
            repartition: {
                especes: repEspeces.filter(piece => piece.count>0),
                cheques: repCheques.filter(cheque=> cheque.montant>0),
                virement: repVir.montant>0 ? repVir : {},
                cb: repCB.montant>0 ? repCB : {}
            },
            commentaire: com,
            eglise: props.don?.eglise?? eglise.number
        }

        let formdata = new FormData()
        formdata.append('don', JSON.stringify(don)); 
        
        const files = cheque_files.filter(f=> f!=='')
        for (let index = 0; index < files.length; index++) {
            formdata.append('file', files[index])
        }
        
        fetch(API.concat(props.edit? `/dons/${eglise._id}/${props.don?._id}` : `/dons/create/${eglise._id}`), {
            method: props.edit? 'PATCH' : 'POST',
            headers:{'Authorization': 'Bearer ' + sessionStorage.getItem('token')},
            body: formdata
        }).then(async(response) => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 403) {
                    alert(await response.text())
                }
                if (response.status === 200) {console.log(response.status)
                    if(props.edit) {
                        const updated = await response.json()
                        props.setDons(old=> {old[old.indexOf(props.don)] = updated; return old})
                        props.close()
                    }else SetOpenChoice(true)
                }
                setSend(false)
            }
        })
    }

    function handleImport(event, index) {
        event.preventDefault();
        if (event.target.files.length>0) {
            const file = event.target.files[0]
            if (!cheque_files.some(f => f.name===file.name && f.size===file.size && f.lastModified===file.lastModified)) {
                setFiles(old => {let newFiles=[...old]; newFiles[index]=event.target.files[0]; return newFiles})            
            }
        }
    }

    function get_donateurs(nums) {
        fetch(API.concat(`/donateurs/by/${JSON.stringify({num:{$in: nums}})}`), {
            method:'GET',
            headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async(response) => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const donateurs = await response.json()
                    const anon = donateurs.filter(donat => donat.nom.toLowerCase() === 'anonyme' && donat.prenom1.toLowerCase() === 'anonyme')
                    setDonateurs(donateurs); setAnonyme(anon[0]);
                    if(props.don?.donateur) setDonateur(props.don?.donateur) 
                    setLoad(false)
                }
            }
        })
    }

    function get_off_spe(eglise, isFeam) {
        fetch(API.concat(`/comptes/by/${JSON.stringify({eglise: eglise, is_offrande: true})}`), {
            method:'GET',
            headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async(response) => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const off_comptes = await response.json()
                    const off = off_comptes.map(compte => {return({libelle: compte.libelle, num:compte.num})})
                    if(isFeam) {setOffrande_label_feam(off)} else setOffrande_label_eglise(off)
                }
            }
        })
    }

    useEffect(()=>{
        if (eglise) {
            get_off_spe(eglise.number, false)
            get_donateurs(props.don?.donateur ? [props.don?.donateur,...eglise.donateurs] : eglise.donateurs)
        }
    }, [eglise])

    useEffect(()=>{
        function get_eglises() {
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{isFederation: false, isUnion: false})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }

        function getOffrSpe_fede() {
            fetch(API.concat('/eglises/by/{"isFederation": "true"}'), {method: 'GET', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }})
            .then(async(response)=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                } else if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const fede = (await response.json())[0]
                    get_off_spe(fede?.number, true)
                }
            })
        }

        if(eglise && !eglise.isFederation) getOffrSpe_fede()
        if(organisation.isFederation && !eglise) {
            get_eglises()
        } else {
            get_off_spe(eglise.number, false)
            get_donateurs(props.don?.donateur ? [props.don?.donateur,...eglise.donateurs] : eglise.donateurs)
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Box style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            {!props.edit && <Header/>}
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Enregistrement des fonds</Typography>
            <Stack sx={{paddingX:'20px', marginTop:'30px'}} spacing={2} direction={'column'}>
                <Stack direction='row' spacing={10} sx={{ alignItems:'center'}}>
                    <Stack direction='row' spacing={2} sx={{alignItems:'center'}}>
                        <Typography>Date*:</Typography>
                        <DatePicker 
                        ariaLabelledBy="Date"
                        wrapperClassName="datepicker"
                        required
                        selected={date} 
                        locale="fr" 
                        dateFormat={'dd/MM/yyyy'}
                        maxDate={new Date()}
                        filterDate={(date)=> date.getDay() === 6}
                        onChange={(date) => setDate(date)} />
                    </Stack>
                    {organisation.isFederation && <TextField select size="small" label='Église' sx={{minWidth:'300px'}} value={egliseId} onChange={e=>setEgliseId(e.target.value)}>
                        {eglises.map(item=><MenuItem key={item._id} value={item._id}>{item.nom} - {item.commune.toUpperCase()}</MenuItem>)}
                    </TextField>}
                    {/* Donateur */}
                    {eglise&&<TextField select size="small" sx={{minWidth:'300px'}} required label="Donateur" value={donateur} onChange={(e)=> setDonateur(e.target.value)}>
                        {loading && <CircularProgress/>}
                        {!loading && <MenuItem value={anonyme.num}>
                            <Typography sx={{fontWeight:'bold'}}>Anonyme</Typography> 
                        </MenuItem>}
                    {!loading && donateurs.sort((a,b)=>`${a.nom} ${a.prenom1} ${a.prenom2?? ''}`.toLowerCase()<`${b.nom} ${b.prenom1} ${b.prenom2?? ''}`.toLowerCase()?-1:1).map((donat) => (
                        donat.nom.toLowerCase() !=="anonyme" && <MenuItem key={donat._id} value={donat.num}>
                            <Typography>{donat.nom.toUpperCase()} <span style={{textTransform:'capitalize'}}>{`${donat.prenom1} ${donat.prenom2?? ''}`}</span></Typography> 
                        </MenuItem>
                    ))}
                        {!loading && <MenuItem value={"0"}>
                            <Typography sx={{color: 'primary', fontWeight:'bold'}}>Nouveau donateur</Typography> 
                        </MenuItem>}
                    </TextField>}
                </Stack>
                {donateur === "0" && <DonateurForm {...{eglise, setEglises, updateDonateurs:(donator)=>updateDonateurs(donator), cancel:()=>setDonateur(""), updateDonateur:(newValue)=>setDonateur(newValue)}} />}
                
                {date!=='' && donateur!=='' && 
                <DonForm 
                eglise={eglise}
                total={total} 
                setTotal={setTotal}
                dime={dime}
                setDime={setDime}
                off_global={offrande_globale}
                setOff_global={setOffrande_globale}
                offSpe_fede={offrande_spe_feam}
                setOffSpe_fede={setOffrande_spe_feam}
                offSpeLabel_fede={offrande_label_feam}
                setOffSpeLabel_fede={setOffrande_label_feam}
                offSpe_local={offrande_spe_eglise}
                setOffSpe_local={setOffrande_spe_eglise}
                offSpeLabel_local={offrande_label_eglise}
                setOffSpeLabel_local={setOffrande_label_eglise}
                />}
                
                {Number(total)>0 && <PaymodeForm 
                total={total}
                reptotal={reptotal}
                setReptotal={setReptotal}
                pay_mode={pay_mode}
                setMode={setMode}
                repCheques={repCheques}
                setRepCheques={setRepCheques}
                repEspeces={repEspeces}
                setRepEspeces={setRepEspeces}
                repVir={repVir}
                setRepVir={setRepVir}
                repCB={repCB}
                setRepCB={setRepCB}
                don_date={date} />}

                {repCheques.filter(cheque=> cheque.montant>0).length>0&&<Box display='flex' flexDirection='column'>
                    <Typography variant="subtitle1" sx={{marginTop:'20px', marginBottom:'10px'}}>Importer le(s) chèque(s)</Typography>
                    <Stack direction='row' spacing={2} flexWrap='wrap' alignItems='center'>{cheque_files.map((file, index)=>(
                        <Stack key={index} direction={'row'} spacing={2} alignItems={'center'}>
                            <input type='file' name='facture_file' accept='.pdf, image/*' onChange={(event)=>{
                                handleImport(event, index)
                            }} />
                            <IconButton onClick={()=>setFiles(old=>{let newf=[...old]; newf.splice(index, 1); return newf})}><Clear/></IconButton>
                        </Stack>
                        ))}
                        {cheque_files[cheque_files.length-1]!=='' && cheque_files.length<5 &&
                        <Button variant="contained" sx={{alignSelf:'flex-start', marginLeft:'20px', marginTop:'10px', textTransform:'none', fontWeight:'bold'}} startIcon={<Add/>} color="grey" 
                        onClick={()=>setFiles(old=>{let newf=[...old]; newf.push(''); return newf})}>
                            Ajouter un fichier
                        </Button>}
                    </Stack>
                </Box>}

                {Number(total)>0 &&<TextField
                label='Commentaire'
                multiline
                sx={{width:'50%', minWidth:'350px', alignSelf:'center'}}
                rows={3}
                value={com}
                onChange={(e)=>setCom(e.target.value)}/>}

                {Number(total)>0 && Number(total)===Number(reptotal) && 
                <Button
                onClick={()=>SetOpen(true)}
                variant="contained"
                disabled={
                    repCheques.filter(cheq=> cheq.montant>0 && (cheq.num_cheque.length<6||cheq.banque==='')).length>0 ||
                    (repCB.montant>0 && (repCB.ref.length<3||repCB.date==='')) ||
                    (repVir.montant>0 && (repVir.ref.length<3||repVir.date===''))
                }
                sx={{ alignSelf:'flex-end', marginRight:'30px' }}
                color="primary"
                >
                    Valider
                </Button>}
            </Stack>
            <Dialog open={open} onClose={()=>SetOpen(false)}>
                <DialogTitle>Vous allez {props.edit? 'enregistrer la modification de don suivante:': 'enregistrer le don suivant:'} </DialogTitle>
                <DialogContent>
                    <Typography>Date: { moment.utc(date).format('DD/MM/YYYY')}</Typography>
                    <Typography textTransform={'capitalize'}>
                        Donateur: {donateurs.filter(donat=> donat.num===donateur)[0]?.nom} {donateurs.filter(donat=> donat.num===donateur)[0]?.prenom1} {donateurs.filter(donat=> donat.num===donateur)[0]?.prenom2}
                    </Typography>
                    <Typography>Dîme: {dime.toFixed(2)}€</Typography>
                    <Typography>Offrande globale: {offrande_globale.toFixed(2)}€</Typography>
                    {offrande_spe_feam.filter(off => off.montant>0).length>0 && <Stack>
                        <Typography>Offrandes spécifiées FÉDÉRALES:</Typography>
                        {offrande_spe_feam.filter(off => off.montant>0).map(off=>
                            <Typography key={off.libelle} sx={{marginLeft: '30px'}}>{off.libelle}: {off.montant.toFixed(2)}€</Typography>)}
                    </Stack>}
                    {offrande_spe_eglise.filter(off => off.montant>0).length>0 && <Stack>
                        <Typography>Offrandes spécifiées LOCALES:</Typography>
                        {offrande_spe_eglise.filter(off => off.montant>0).map(off=>
                            <Typography key={off.libelle} sx={{marginLeft: '30px'}}>{off.libelle}: {off.montant.toFixed(2)}€</Typography>)}
                    </Stack>}
                    <Typography>Répartition:</Typography>
                    {repEspeces.filter(piece => piece.count>0).length>0 && <Stack sx={{marginLeft: '30px'}}>
                        <Typography>Espèces:</Typography>
                        {repEspeces.filter(piece => piece.count>0).sort(function(a, b) {return b.montant - a.montant}).map(piece=>
                            <Typography key={piece.montant} sx={{marginLeft: '20px'}}>{piece.count} {piece.montant<5 ?'pièce' : 'billet'}{piece.count>1 && 's'} de {piece.montant.toFixed(2)}€</Typography>)}
                    </Stack>}
                    {repCheques.filter(cheque => cheque.montant>0).length>0 && <Stack sx={{marginLeft: '30px'}}>
                        <Typography>Chèques:</Typography>
                        {repCheques.filter(cheque => cheque.montant>0).map(cheque=>
                            <Typography key={cheque.num_cheque} sx={{marginLeft: '20px'}}>chèque {cheque.banque} n°{cheque.num_cheque} de {cheque.montant.toFixed(2)}€</Typography>)}
                    </Stack>}
                    {repVir.montant>0 && <Typography sx={{marginLeft: '30px'}}>Virment du {moment.utc(repVir.date).format('DD/MM/YYYY')} référencé {repVir.ref} de {repVir.montant.toFixed(2)}€</Typography>}
                    {repCB.montant>0 && <Typography sx={{marginLeft: '30px'}}>Paiement CB du {moment.utc(repCB.date).format('DD/MM/YYYY')} ticket marchand {repCB.ref} de {repCB.montant.toFixed(2)}€</Typography>}
                    {com!=='' && <Typography>Commentaire: {com}</Typography>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>SetOpen(false)}>Annuler</Button>
                    <Button onClick={handleSubmit}>Confirmer</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={open_choice} onClose={()=>navigate("/")}>
                <DialogTitle>Le don a bien été enregistrée</DialogTitle>
                <DialogActions>
                    <Button onClick={()=>window.location.reload()}>Nouveau don</Button>
                    <Button href="/versements/enregistrement">Versements</Button>
                </DialogActions>
            </Dialog>
            <Backdrop open={sending}><CircularProgress color="inherit" /></Backdrop>
        </Box>
    )
}